import { render, staticRenderFns } from "./catalogPage.vue?vue&type=template&id=7053c3b0&"
import script from "./catalogPage.vue?vue&type=script&lang=ts&"
export * from "./catalogPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports